import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

/**
 * The account service provides service for the user account such as password change
 * profile fetching, user submissions, and such
 */
@Injectable({providedIn: "root"})
export class LoadingService {

  _isLoading = new BehaviorSubject<boolean>(false)

  constructor() {
  }

  setLoading(flag: boolean) {
    this._isLoading.next(flag)
  }
}
